<template>
<main class="container-1">
        <div class="container-header">
            <Breadcrumb
                v-bind:links="routesBread"
            >
            </Breadcrumb>
            <h2>Nuevo documento</h2>
        </div>
        <div class="container-body">
            <label for="filename">Nombre</label>
            <input id="filename" v-model="doc.filename" type="text" maxlength="150"
            name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required|max:150'"
            :placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

            <label for="description">Descripción</label>
            <input id="description" v-model="doc.description" type="text" maxlength="450"
            name="descripción" :class="{'error' : errors.has('descripción') }" v-validate="'required|max:450'"
            :placeholder="[[errors.has('descripción') ? errors.first('descripción') : 'Ingresa una descripción']]"/>

            <label for="document-groups">Grupos del documento</label>
            <div id="document-groups">
                <div class="group-chips" v-if="doc.id_groups.length">
                    <span class="group-chip" v-for="idGroup in doc.id_groups" :key="idGroup">
                        {{ groupNameById(idGroup) }}
                        <button type="button" class="group-chip-remove" @click="removeGroup(idGroup)">×</button>
                    </span>
                </div>
                <select v-model="groupToAdd" :class="{'error': groupError}" @change="addGroup()">
                    <option value="" disabled>Selecciona un grupo</option>
                    <option v-for="item in availableGroups" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
                <span v-if="groups.length === 0" class="group-empty">No hay grupos disponibles.</span>
            </div>

            <label for="file">Archivo</label>
            <input
                id="file"
                ref="fileInput"
                type="file"
                accept=".pdf,.mp4"
                @change="onFileSelected"
            />
            <DocumentPreview
                v-if="previewUrl"
                :url="previewUrl"
                :extension="previewExtension"
                :name="doc.file ? doc.file.name : ''"
                :size="doc.file ? doc.file.size : 0"
            />
            <button
                v-if="previewUrl"
                type="button"
                class="btn btn-secondary"
                @click="removeFile()"
            >Quitar archivo</button>
            <div class="container-action-left" style="justify-content: start;">
                <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
                <button class="btn btn-secondary" :disabled="submitting" v-on:click="onClickGoNext()">Subir Documento</button>
                <button v-if="submitting" class="btn btn-secondary" v-on:click="onClickCancel()">Cancelar</button>
            </div>
            <div v-if="submitting" class="upload-status">Subiendo y analizando el archivo…</div>
        <!--mensaje de error-->
                <div v-if="errors.any() || validationMessage" class="validation-summary">
                    <div v-if="validationMessage" class="validation-summary__message"
                    >
                        {{ validationMessage }}
                    </div>

                    <div
                        v-for="error in errors.items" :key="error.id" class="validation-summary__error"
                    >
                        {{ error.msg }}
                    </div>
                </div>
    </div>

</main>
</template>
<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import DocumentPreview from '@/components/DocumentPreview.vue'

import {restDocument} from '@/components/mixin/restDocument.js'

export default{
    name: 'DocumentsNew',
    mixins: [restDocument],
    data(){
        return{
            validationMessage: '',
            submitting: false,
            previewUrl: '',
            previewExtension: '',
            cancelSource: null,
            groupToAdd: '',
            groupError: false
        }
    },
    components:{
        Breadcrumb,
        DocumentPreview
    },
    computed:{
        routesBread: function() {
            return [
                {name: 'Documentos', path:'/documentos'},
                {name: 'Nuevo Documento'}
            ]
        },
        availableGroups: function() {
            return this.groups.filter((item) => !this.doc.id_groups.includes(item.id))
        }
    },
    props: [],
    methods: {
        onClickGoBack: function() {
            window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push('/documentos/')
        },

        onClickGoNext: function() {

            this.groupError = this.doc.id_groups.length === 0
            if (this.groupError) {
                this.validationMessage = 'Selecciona al menos un grupo para el documento.'
                return
            }

            this.$validator.validateAll().then(valid => {
                //actualizado manejo de error (mostrar mensaje a usuario) segun observacion SENAPRED 06/2026
                //("3. Al  crear un usuario con un correo existente, no se crea pero, no arroja ningún mensaje que indique el por qué.")
                if (!valid) {
                    this.validationMessage = 
                    'Hay errores en el formulario.';
                    return;
                }

                if (!this.doc.file){
                    this.validationMessage =
                    'Debe seleccionar un archivo.';
                    return;
                }
                this.submitting = true;
                this.cancelSource = this.$http.CancelToken.source();
                return this.postDoc(this.cancelSource.token).then(() => {
                    this.submitting = false;
                    this.cancelSource = null;
                });
            })
                .catch(error =>{
                    this.validationMessage = 'Ocurrió un error inesperado';
                    this.submitting = false;
                })
        },

        groupNameById: function(idGroup) {
            const group = this.groups.find((item) => item.id === idGroup)
            return group ? group.name : 'Grupo desconocido'
        },

        addGroup: function() {
            if (this.groupToAdd && !this.doc.id_groups.includes(this.groupToAdd)) {
                this.doc.id_groups.push(this.groupToAdd)
                this.groupToAdd = ''
                this.groupError = false
                if (this.validationMessage === 'Selecciona al menos un grupo para el documento.') {
                    this.validationMessage = ''
                }
            }
        },

        removeGroup: function(idGroup) {
            this.doc.id_groups = this.doc.id_groups.filter((item) => item !== idGroup)
        },

        onFileSelected(event) {

            const file = event.target.files[0]

            if (!file) {
                return
            }

            const extension =
                file.name
                    .split('.')
                    .pop()
                    .toLowerCase()

            if (!this.allowedExtensions.includes(extension)) {

                this.validationMessage =
                    'Solo se permiten archivos PDF o MP4.'

                //Se descarta también la selección válida anterior: el input queda
                //vacío y conservar doc.file subiría un archivo que ya no se ve.
                this.removeFile()

                return
            }

            const maxSize = this.maxFileSizeByExtension[extension]
            if (file.size > maxSize) {

                this.validationMessage =
                    `El archivo ${extension.toUpperCase()} no puede superar los ${maxSize / (1024 * 1024)} MB.`

                this.removeFile()

                return
            }

            this.validationMessage = ''

            this.doc.file = file

            this.clearPreview()
            this.previewUrl = URL.createObjectURL(file)
            this.previewExtension = extension

            //Chequeo de contenido sólo por UX: evita subir 128 MB para recibir un
            //rechazo del servidor. El control real es la verificación MIME del backend.
            //Blob.slice referencia un rango: no copia el archivo a memoria.
            const reader = new FileReader()
            reader.onload = () => {
                //El lector es async: si ya se eligió otro archivo, este rechazo
                //borraría el preview del archivo nuevo.
                if (this.doc.file !== file) return
                const bytes = new Uint8Array(reader.result)
                const isPdf = bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 &&
                    bytes[3] === 0x46 && bytes[4] === 0x2d
                const isMp4 = bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 &&
                    bytes[7] === 0x70
                if (!isPdf && !isMp4) {
                    this.validationMessage = 'El contenido del archivo no corresponde a un PDF o MP4.'
                    this.removeFile()
                }
            }
            reader.readAsArrayBuffer(file.slice(0, 12))
        },

        clearPreview() {

            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }

            this.previewUrl = ''

            this.previewExtension = ''

        },

        removeFile() {

            this.clearPreview()

            this.doc.file = null

            this.$refs.fileInput.value = ''

        },

        onClickCancel: function() {
            //Corta la espera del cliente, no el trabajo del servidor: si el
            //archivo ya se transmitió completo, el backend sigue escaneando y
            //puede terminar insertando el documento igual. La cancelación
            //cooperativa server-side está fuera del alcance de QA-48.
            if (this.cancelSource) {
                this.cancelSource.cancel()
                this.cancelSource = null
            }
            this.submitting = false
            this.validationMessage = ''
        }
    },
    created () {
        this.$store.getters.getPermissions?.documents ? true : this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getDocumentGroups().catch(() => {})
    },
    beforeDestroy () {
        //Un MP4 de 128MB rechazado queda anclado en memoria toda la sesión si no se revoca.
        this.clearPreview()
        //Una subida en vuelo resolvería con un $router.push desde un componente
        //que el usuario ya dejó atrás.
        if (this.cancelSource) {
            this.cancelSource.cancel()
        }
    }
}
</script>
<style lang="scss" scoped>
.validation-summary {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #dc3545;
    border-radius: 4px;
    background-color: #fff5f5;
}

.validation-summary__message {
    color: #dc3545;
    font-weight: 600;
    margin-bottom: 0.75rem;
}

.validation-summary__error {
    color: #dc3545;
    line-height: 1.5;
}

.validation-summary__error:not(:last-child) {
    margin-bottom: 0.25rem;
}

.upload-status {
    margin-top: 1rem;
    color: #555;
}
.group-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.group-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem 0.5rem;
    border-radius: 999px;
    background-color: #e9ecef;
    font-size: 0.85em;
}

.group-chip-remove {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1em;
    line-height: 1;
}

.group-empty {
    display: block;
    margin-top: 0.35rem;
    color: var(--color-ghost);
    font-size: 0.85rem;
}
</style>
